@if (text) {
  <div #container class="m-0 js-container-toggle-text container-toggle-text">
    <span class="first-part"> {{ getPartOfString(text, 1) }}@if (hasSecondPart(text)) {
      <span class="ellipse">...</span>
    } </span>
    @if (hasSecondPart(text)) {
      <span
        class="show-more"
        (click)="toggleText()"
        (keyup.enter)="toggleText()"
        (keyup.space)="toggleText()"
        [attr.tabindex]="0"
        >
        {{ 'toggleText.showMore' | cxTranslate }}</span
        >
      }
      @if (hasSecondPart(text)) {
        <span class="last-part">
          {{ getPartOfString(text, 2) }}
        </span>
      }
      @if (hasSecondPart(text)) {
        <span
          class="show-less"
          (click)="toggleText()"
          (keyup.enter)="toggleText()"
          (keyup.space)="toggleText()"
          [attr.tabindex]="0"
          >
          {{ 'toggleText.showLess' | cxTranslate }}</span
          >
        }
      </div>
    }
